
document.addEventListener('DOMContentLoaded', () => {
  
  // === Header transparent

  const transparentHeader = document.querySelector('.header--transparent-both, .header--transparent-mobile, .header--transparent-desktop');
  if (transparentHeader !== null && transparentHeader !== undefined) {

    // --- Init
    if (window.scrollY > 60) {
      transparentHeader.classList.add('no-transparent');
    } else {
      transparentHeader.classList.remove('no-transparent');
    }

    // --- On scroll
    window.addEventListener('scroll', function(event) {
      if (window.scrollY > 60) {
        transparentHeader.classList.add('no-transparent');
      } else {
        transparentHeader.classList.remove('no-transparent');
      }
    });
    
  }

});
